<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import type { BlogDetailProps } from "./BlogDetailProps.js";
	import Icon from "../components/Icon.svelte";
	import arrowDown from "../../../core/assets/icons/filled-arrow-down.svg?raw";
	import BlogPosts from "../components/BlogPosts.svelte";
	import Content from "../components/Content.svelte";
	import SimilarReferences from "../components/References/SimilarReferences.svelte";
	import HelpSection from "../components/HelpSection.svelte";
	import Contact from "../components/Contact.svelte";
	import arrowLeft from "../../../core/assets/icons/filled-arrow-left.svg?raw";
	import PhotoGalleryCarousel from "../components/PhotoGalleryCarousel.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { blogPathMap } from "../../../core/schema/paths/blogPathMap";

	type $$Props = BlogDetailProps;

	const { blogPost, blogPosts, references } = $$restProps as $$Props;
	const { STORAGE_URL, TENANT_LOCALE } = getGlobalSettings();

	setContext(thumbnailImageContextKey, `${STORAGE_URL}/${blogPost.primaryImage.path}`);

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Layout>
	<button
		class="ml-6 mt-4 flex cursor-pointer gap-4 md:ml-10 md:mt-8"
		on:click={() => {
			window.location.href = `/${blogPathMap[TENANT_LOCALE]}`;
		}}
	>
		<Icon icon={arrowLeft} class="text-gray h-4 w-4" />
		<span class="text-xs font-extrabold">Zpět</span>
	</button>

	<div class="mx-auto mt-7 flex flex-col justify-center px-4">
		<span
			class="font-quicksand text-primary m-0 text-center text-[1.375rem] font-bold uppercase leading-10 tracking-[0.3em] md:text-[2rem]"
		>
			Blog
		</span>
		<h1
			class="mx-auto mb-8 mt-16 max-w-[70.625rem] text-center text-lg font-bold text-[#8F8F8F] sm:text-[2rem] md:text-[3rem]"
		>
			{nbspify(blogPost.title)}
		</h1>
		<p class="text-md text-bito-black mx-auto max-w-[50.25rem] text-center font-extrabold md:text-[1.5rem]">
			{nbspify(blogPost.perex)}
		</p>
	</div>

	{#if blogPost.images.length > 0}
		<div class="mt-16">
			<a
				aria-label="Přeskočit na obsah"
				href="#obsah"
				class="border-gray text-secondary hover:border-tertiary hover:text-tertiary group mx-auto flex h-[4.5rem] w-[4.5rem] items-center justify-center border"
			>
				<Icon icon={arrowDown} class="h-4 w-4 transition-transform duration-200 ease-out group-hover:scale-[130%]" />
			</a>

			<PhotoGalleryCarousel
				photoGallery={blogPost.images}
				thumbnailImage={blogPost.images[0] ?? blogPost.primaryImage}
			/>
		</div>
	{/if}

	<div
		id="obsah"
		class="mx-auto mt-20 flex w-full max-w-[41.875rem] flex-col items-center gap-16 px-4 md:px-8 lg:w-full lg:flex-row lg:items-start lg:px-0 xl:gap-[8.438rem]"
	>
		<Content content={blogPost.content} contentClass="ckeditor-bito-text ckeditor-content" />
	</div>

	<div class="container flex flex-col gap-20 lg:mt-20 lg:mt-32 lg:gap-32">
		<BlogPosts {blogPosts} title="Doporučujeme" />
		{#if references.length > 0}
			<SimilarReferences similarReferences={references} title="Naše reference" />
		{/if}
	</div>
	<div class="mt-20 flex flex-col gap-20 lg:mt-32 lg:gap-32">
		<HelpSection />
		<Contact />
	</div>
</Layout>
